import EmailTemplateModal from './component'
import enhance from './EnhanceWithAssistantConfig'

import { compose, withHandlers, withProps, withStateHandlers } from 'recompose'




export default enhance(
  compose(
    withStateHandlers(
      ({ settingName }) => ({ selectedSettingName: settingName }),
      {
        selectSetting: () => (selectedSetting) => ({ selectedSettingName: selectedSetting })
      }
    ),
    withProps(({ selectedSettingName, assistantAgentSettings, editingAssistantAgentSettings }) => {
      return {
        initialSettings: assistantAgentSettings && assistantAgentSettings.get(selectedSettingName),
        editingSettings: editingAssistantAgentSettings && editingAssistantAgentSettings.get(selectedSettingName)
      }
    }),
    withProps(({ initialSettings, editingSettings }) => ({
      delayTime: editingSettings && editingSettings.get('delayTime'),
      initialEmailSubject: initialSettings && initialSettings.get('emailSubject'),
      initialEmailBody: initialSettings && initialSettings.get('emailBody'),
    })),
    withHandlers({
      onDelayEdit: ({ actions, selectedSettingName, editingSettings }) => (newDelayTime) => {
        const newSettings = editingSettings.set("delayTime", newDelayTime)
        return actions.onUpdate({ settingName: selectedSettingName, newSettings })
      },
      onSubjectEdit: ({ actions, selectedSettingName, editingSettings }) => (newSubject) => {
        const newSettings = editingSettings.set("emailSubject", newSubject)
        return actions.onUpdate({ settingName: selectedSettingName, newSettings })
      },
      onBodyEdit: ({ actions, selectedSettingName, editingSettings }) => (newBody) => {
        const newSettings = editingSettings.set("emailBody", newBody)
        return actions.onUpdate({ settingName: selectedSettingName, newSettings })
      },
      sendTestEmail: ({ actions, selectedSettingName }) => () => actions.sendTestEmail(selectedSettingName)
    })
  )(EmailTemplateModal))



// WEBPACK FOOTER //
// ./src/scripts/components/EmailTemplateModal/index.js